import { render, staticRenderFns } from "./ProveedorNumSap.vue?vue&type=template&id=bf1bf810&"
import script from "./ProveedorNumSap.vue?vue&type=script&lang=js&"
export * from "./ProveedorNumSap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports